import { connect } from 'react-redux';
import { jsx, css } from '@emotion/core';
import {
  primary_dark15,
  primary_s5_l70,
  primary_darken_5,
} from '../lib/colors';

const getStyle = (primaryColor, uiVariantButton) => css`
  &.btn {
    padding: ${uiVariantButton === '3' ? '5px 25px' : '7px 25px'};
    font-size: ${uiVariantButton === '3' ? '14px' : '12px'};
    border-width: 1px;
    font-weight: 600;
    text-transform: ${uiVariantButton === '3' ? 'none' : 'uppercase'};
    letter-spacing: ${uiVariantButton === '3' ? '0' : '0.5px'};
    transition: all 0.2s ease-in-out;
    border-radius: ${uiVariantButton === '1'
      ? '12px'
      : uiVariantButton === '3'
      ? '6px'
      : 0} !important;

    &:focus,
    &:active,
    &:active:focus {
      box-shadow: none;
      outline: none;
    }
  }

  &.btn-thick {
    padding: ${uiVariantButton === '3' ? '12px 18px' : '14px 18px'};

    &.btn-login {
      padding: ${uiVariantButton === '3' ? '10px 25px' : '12px 25px'};
    }

    &.btn-cart {
      padding: ${uiVariantButton === '3' ? '15px 30px' : '17px 30px'};
    }
  }

  &.btn-short {
    padding: ${uiVariantButton === '3' ? '2px 16px' : '4px 16px'};
  }

  &.btn-primary {
    background-color: ${primaryColor};
    border-color: ${primary_darken_5(primaryColor)};
    &:focus,
    &:hover,
    &:active,
    &:not(:disabled):not(.disabled):active {
      background-color: ${primary_dark15(primaryColor)};
      border-color: ${primary_dark15(primaryColor)};
    }
  }

  &.btn-inverse {
    background-color: transparent;
    color: #fff;
    border-color: #fff;

    &:focus,
    &:hover,
    &:active,
    &:not(:disabled):not(.disabled):active {
      background-color: #fff;
      color: ${primaryColor};
    }
  }

  &.btn-outline {
    background-color: transparent;
    color: ${uiVariantButton === '3' ? '#4f4f4f' : primaryColor};
    border-color: ${primaryColor};

    &:focus,
    &:hover,
    &:active,
    &:not(:disabled):not(.disabled):active {
      background-color: ${primaryColor};
      color: #fff;
    }
  }

  &.btn-grey {
    background-color: transparent;
    color: ${primary_s5_l70(primaryColor)};
    border-color: ${primary_s5_l70(primaryColor)};

    &:focus,
    &:hover,
    &:active,
    &:not(:disabled):not(.disabled):active {
      background-color: ${primary_s5_l70(primaryColor)};
      color: #fff;
    }
  }
`;

const Button = props => {
  const cleanProps = { ...props };
  delete cleanProps.primaryColor;
  delete cleanProps.uiVariantButton;
  delete cleanProps.dispatch;

  return (
    <button
      {...cleanProps}
      css={getStyle(props.primaryColor, props.uiVariantButton)}
    />
  );
};

const mapStateToProps = state => ({
  primaryColor: state.store.data.loghiTemplate.brandColor,
  uiVariantButton: state.store.data.uiVariants.buttons,
});

export default connect(mapStateToProps)(Button);
